<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    @cancel="close"
    cancelText="关闭"
  >
    <!-- <JEditor v-model="richText" /> -->
    <WangEditor v-if="visible" v-model="richText" />
  </j-modal>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { postAction, putAction, uploadAction } from '@/api/manage'
// import JEditor from '@/components/jeecg/JEditor'
import WangEditor from '@/components/WangEditor'

export default {
  name: 'InventoryRichModal',
  components: { Editor, Toolbar, WangEditor },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      editor: null,
      richText: '',
      field: '',
    }
  },
  methods: {
    show(record) {
      this.visible = true
      this.richText = record.content
      this.title = (record.isEdit ? '编辑' : '新增') + record.title
      this.field = record.field
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$emit('handleOk', {
        field: this.field,
        content: this.richText,
      })
      this.close()
    },
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
